export const isPwaMode = (): boolean => {
	return window.matchMedia('(display-mode: standalone)').matches
}
